type THeadProps = {
  children: React.ReactNode;
};

export const THead = ({ children }: THeadProps) => {
  return <>{children}</>;
};
